import { QueryOptions } from "@hooks/queries/types";

export function buildDefaultQueryOptions<T extends QueryOptions>(options?: T) {
  return { ...options };
}
